/**
 * @description Converts the given date time into a date time as a string without the time zone suffix
 * @returns The date time representation as a string without the time zone suffix
 */
export function convertToDateTimeWithoutTimeZoneSuffix(
  date: Date,
  hours?: number,
  minutes?: number
): string {
  //In order to remove the timezone from the selected date vraiable
  //we need to manually construct the date time as a string due to the fact that
  //all Date time methods add the time zone suffix to the generated result.
  //See -> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date

  let month: string;

  if (date.getMonth() === 0) {
    month = date.getMonth() + '1';
  } else if (date.getMonth() > 0 && date.getMonth() < 9) {
    month = '0' + (date.getMonth() + 1);
  } else {
    month = (date.getMonth() + 1).toString();
  }

  const dateTimeWithoutTimeZone =
    date.getFullYear() +
    '-' +
    month +
    '-' +
    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
    (hours != null || minutes != null
      ? 'T' +
        (hours < 10 ? '0' + hours : hours.toString()) +
        ':' +
        (minutes < 10 ? '0' + minutes : minutes.toString()) +
        ':' +
        '00'
      : '');

  return dateTimeWithoutTimeZone;
}

export function toUTCDateTime(d: Date | string | number): Date {
  if (typeof d === 'string' && !d.includes('T')) {
    d += 'T00:00:00';
  }
  const date = new Date(d);
  const clearTimeZoneDate = toUTCDateClearTimeZone(date);
  return new Date(
    clearTimeZoneDate.getUTCFullYear(),
    clearTimeZoneDate.getUTCMonth(),
    clearTimeZoneDate.getUTCDate(),
    date.getHours(),
    date.getMinutes()
  );
}

function toUTCDateClearTimeZone(d: Date): Date {
  const date = new Date(d);
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
}
